import { CustomError } from '../../../errors';

export class NameValidationError extends CustomError {
  constructor() {
    const name = 'NameValidationError';
    const message = 'Group with this name already exists';
    super(name, message);
  }
}
